var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobiusLoop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "2 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2875 29.0932C14.4272 19.7755 14.4272 19.7755 14.4272 19.7755C22.6833 5.19602 22.6833 5.19602 22.6833 5.19602C24.9645 1.14008 33.4378 1.03046 36.3709 4.5383C40.3902 11.3347 40.3902 11.3347 40.3902 11.3347L30.2875 29.0932Z",
    fill: "#009900",
    stroke: "black",
    strokeWidth: 1.0962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4689 51.3461C8.99559 51.3461 8.99559 51.3461 8.99559 51.3461C5.73664 50.9899 0.305051 44.2208 3.564 38.0821C7.25748 31.8338 7.25748 31.8338 7.25748 31.8338C1.5 28.4355 1.5 28.4355 1.5 28.4355C19.7501 28.4355 19.7501 28.4355 19.7501 28.4355C28.9838 44.4401 28.9838 44.4401 28.9838 44.4401C23.2263 41.2611 23.2263 41.2611 23.2263 41.2611L17.4689 51.3461Z",
    fill: "#009900",
    stroke: "black",
    strokeWidth: 1.0962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3041 53.6484C39.3041 72.3935 39.3041 72.3935 39.3041 72.3935C18.9899 72.3935 18.9899 72.3935 18.9899 72.3935C17.795 72.5031 16.9259 71.2973 16.2742 70.3107C6.71457 53.21 6.8232 53.3196 6.38867 52.7715C6.90467 53.21 7.47499 53.6484 9.10446 53.6484H39.3041Z",
    fill: "#009900",
    stroke: "black",
    strokeWidth: 1.0962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5004 53.6482C76.5644 53.429 76.8903 52.8809 77.4334 52.552C67.222 70.749 67.222 70.749 67.222 70.749C66.7875 71.6259 65.9185 72.3933 64.6149 72.3933C53.3172 72.3933 53.3172 72.3933 53.3172 72.3933C53.3172 79.0801 53.3172 79.0801 53.3172 79.0801C44.0835 63.1852 44.0835 63.1852 44.0835 63.1852C53.3172 47.1807 53.3172 47.1807 53.3172 47.1807C53.3172 53.6482 53.3172 53.6482 53.3172 53.6482H74.5004Z",
    fill: "#009900",
    stroke: "black",
    strokeWidth: 1.0962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 33.8077C72.2189 24.5996 72.2189 24.5996 72.2189 24.5996C80.5835 38.9598 80.5835 38.9598 80.5835 38.9598C83.6252 44.8793 78.4109 50.5795 74.9347 51.2373C66.3527 51.2373 66.3527 51.2373 66.3527 51.2373L56.25 33.8077Z",
    fill: "#009900",
    stroke: "black",
    strokeWidth: 1.0962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6518 3.1133C38 2.23634 36.6964 1.14014 35.5015 0.920898C56.9019 0.920898 56.9019 0.920898 56.9019 0.920898C58.0969 0.920898 59.1832 1.35938 59.7263 2.34596C65.2666 12.2118 65.2666 12.2118 65.2666 12.2118C70.8068 9.03277 70.8068 9.03277 70.8068 9.03277C61.7903 24.818 61.7903 24.818 61.7903 24.818C43.7575 24.818 43.7575 24.818 43.7575 24.818C49.1891 21.5294 49.1891 21.5294 49.1891 21.5294L38.6518 3.1133Z",
    fill: "#009900",
    stroke: "black",
    strokeWidth: 1.0962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiusLoop);
export default __webpack_public_path__ + "static/media/mobius-loop.b67738eeda08d11a0d27e94b1c31c32d.svg";
export { ForwardRef as ReactComponent };